<template>
  <div class="create">
    <div class="topic_top">
      <div class="uploadPage_toptitle">
        <div class="uploadPage_toptitlebox">
          <van-icon
            class="uploadPage_back"
            name="arrow-left"
            @click="backClick"
          />
          <div class="uploadPage_title">创建话题</div>
          <span v-show="this.$store.state.system !== 'android'"></span>
          <van-icon
            class="fork"
            name="close"
            v-show="
              this.$store.state.system == 'android' &&
              applets != 'xcx' &&
              this.$store.state.isInGame
            "
            @click="closeCommunity"
          />
        </div>
      </div>
    </div>
    <van-field
      id="field"
      v-model="value"
      rows="2"
      autosize
      label=""
      type="textarea"
      maxlength="15"
      placeholder="写下要创建的话题~"
      show-word-limit
      @focus="focus"
      @blur="blur"
    />
    <div class="create_btn" @click="subjectCreate">创建</div>
    <div v-show="tipFlag" class="tipbox">
      <successful v-if="tip == 1" :content="tipcontent"></successful>
      <prompt v-if="tip == 2" :content="tipcontent"></prompt>
    </div>
  </div>
</template>
<script>
import get from "../../../api/get";
import successful from "../../tip/successful.vue";
import prompt from "../../tip/prompt.vue";
import qs from "qs";
import { Toast } from "vant";
import * as _code from "../../../utils/code";
export default {
  name: "create",
  components: { successful, prompt },
  data() {
    return {
      applets: window.user.weixcode ? "xcx" : "",
      value: "",
      // create_btn_focus: "",
      tipFlag: false,
      tip: 0,
      tipcontent: "",
    };
  },
  methods: {
    focus() {
      // this.create_btn_focus = "create_btn_focus";
    },
    blur() {
      // this.create_btn_focus = "";
    },
    subjectCreate() {
      if (this.value == "") {
        Toast("您还未输入话题");
        return;
      }
      let obj = {
        subjectName: this.value,
      };
      get.subjectCreate(qs.stringify(obj)).then((res) => {
        let data = res.data;
        if (data.code == 0) {
          this.tipChang(1, "创建成功");
          setTimeout(() => {
            this.tipFlag = false;
            let objs = {
              id: data.data,
              subjectName: this.value,
            };
            this.$emit("addClick", objs);
          }, 1000);
        } else {
          let code = data.code;
          let voteErr = _code.code.vote;
          let msg = voteErr[code] ? voteErr[code] : voteErr["other"] + code;
          this.tipChang(2, msg);
          setTimeout(() => {
            this.tipFlag = false;
          }, 1000);
        }
      });
    },
    tipChang(id, content) {
      this.tipcontent = content;
      this.tip = id;
      this.tipFlag = true;
    },
    backClick() {
      this.$emit("goCreate", false);
    },
    closeCommunity() {
      window.pd.onBBSClose();
    },
  },
};
</script>
<style scoped>
</style>